import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import FactionMpProvider from "@/core/data-provider/data-mp/faction/faction-mp-provider";
import GameMpProvider from "@/core/data-provider/data-mp/game/game-mp-provider";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import toast from "@/domains/toasts/helpers/toast";

type KnownErr = Error & { knownI18nKey?: boolean };

export function useLeaveFaction() {
  const { t, i18n } = useTranslation("faction");

  return useMutation({
    mutationFn: async () => {
      const response = await FactionMpProvider.leave();

      if (response instanceof RpcMpProviderSuccessResponse) {
        return;
      }

      const messageKey = response?.error?.message ?? "Unknown";
      const knownI18nKey = i18n.exists(`faction:faction.errors.${messageKey}`);
      const error = new Error(messageKey) as KnownErr;
      error.knownI18nKey = knownI18nKey;
      throw error;
    },
    onSuccess: () => {
      toast.success(t("faction.toast.leaveSuccess"));
      GameMpProvider.closeCurrentInterface(true);
    },
    onError: (err) => {
      const error = err as KnownErr;
      console.error(error);
      if (error.knownI18nKey) {
        toast.error(t(`faction.errors.${error.message}`));
      } else {
        toast.error(t("faction.toast.leaveError"));
      }
    },
  });
}
